import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ScrollSyncDirective } from '@rma/generic/ui/scroll-sync';

@Component({
  selector: 'rma-comparison-table',
  templateUrl: './comparison-table.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ScrollSyncDirective],
  host: {
    class: 'block overflow-hidden rounded-lg border border-steel-10 bg-white',
  },
})
export class ComparisonTableComponent {
  readonly heading = input.required<string>();
  readonly subheading = input<string>();
}
